export const CRITERION_ENTITY = "Criterion"
export const CRITERION_SCORE_ENTITY = "CriterionScore"

export const SUB_CRITERION_ENTITY = "SubCriterion"
export const SUB_CRITERION_PARAM_ENTITY = "SubCriterionParameter"
export const SUB_CRITERION_PARAM_VALUE_ENTITY = "SubCriterionParameterValue"


export const ENERGY_CARRIER_ENTITY = "EnergyCarrier"
export const MATERIAL_ENTITY = "Material"
export const MATERIAL_CATEGORY_ENTITY = "MaterialCategory"
export const MATERIAL_USAGE_GROUP_ENTITY = "MaterialUsageGroup"

export const PROJECT_ENTITY = "Project"
export const PROJECT_VERSION_ENTITY = "ProjectVersion"
export const PROJECT_CRITERION_VERSION_ENTITY = "ProjectCriterionVersion"
export const PROJECT_VERSION_ENERGY_CARRIER_ENTITY = "ProjectVersionEnergyCarrier"
export const PROJECT_VERSION_MATERIAL_ENTITY = "ProjectVersionMaterial"
export const PROJECT_MATERIAL_ENTITY = "ProjectMaterial"

export const PROJECT_VERSION_LIFESPAN_ENTITY = "Lifespan"
export const PROJECT_VERSION_PARAM_VALUE_ENTITY = "ProjectVersionParamValue"
export const PROJECT_VERSION_ROOM_ENTITY = "ProjectVersionRoom"
export const PROJECT_VERSION_ROOM_TYPE_ENTITY = "ProjectVersionRoomType"
export const PROJECT_VERSION_ROOM_CATEGORY_ENTITY = "ProjectVersionRoomCategory"
export const AREA_ENTITY = "Area"
export const PROJECT_VERSION_AREA_ENTITY = "ProjectVersionArea"
export const PROJECT_VERSION_DOOR_ENTITY = "ProjectVersionDoor"
export const PROJECT_VERSION_WINDOW_ENTITY = "ProjectVersionWindow"
export const PROJECT_VERSION_TREE_ENTITY = "ProjectVersionTree"
export const PROJECT_VERSION_LOP_FILLINGS_ENTITY = "ProjectVersionLopFilling"
export const PROJECT_VERSION_LOP_PROFILES_ENTITY = "ProjectVersionLopProfile"
export const PROJECT_VERSION_PARKING_ENTITY = "ProjectVersionParking"

export const PROJECT_RUNOFF_COEFFICIENT_ENTITY = "ProjectVersionRunoffCoefficient"
export const PROJECT_VERSION_CAPACITIES_ENTITY = "ProjectVersionCapacity"




// WEBPACK FOOTER //
// ./src/sbtool/entityConstants.ts